import { useState, useEffect } from "react";
import { TextField, Box, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { sendNewUserData } from "../redux/asyncThunk/userActions";

export default function NewPasswordForm({ token }) {
  const dispatch = useDispatch();
  const messages = useSelector((state) => state.user.messages);
  const [newpass, setNewpass] = useState({ pass: "", confirmPass: "" });

  const [message, setMessage] = useState({
    type: "",
    message: "",
  });

  useEffect(() => {
    setMessage(...messages);
  }, [messages]);

  const changeRegData = (event) => {
    setMessage({
      type: "",
      message: "",
    });
    setNewpass((prev) => ({
      ...prev,
      [event.target.id]: event.target.value,
    }));
  };

  const handleSaveNewPasswordButton = () => {
    if (newpass.pass !== newpass.confirmPass) {
      setMessage({
        type: "error",
        message: "Пароли не совпадают",
      });
    } else {
      dispatch(sendNewUserData({ token, pass: newpass.pass }));
    }
  };

  return (
    <div className={"reset_form"} style={{ height: "290px" }}>
      <Box
        onChange={(event) => changeRegData(event)}
        component="form"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          height: "100%",
          alignItems: "center",
          gap: "10px",
          padding: "10px 0",
        }}
      >
        <Typography
          sx={{ color: "white", fontSize: "18px", fontWeight: "bold" }}
        >
          Установите новый пароль
        </Typography>
        <TextField
          id="pass"
          label="Пароль"
          variant="filled"
          type="password"
          value={newpass.pass || ""}
          sx={{ bgcolor: "white", width: "80%" }}
        />
        <TextField
          id="confirmPass"
          label="Повторите пароль"
          variant="filled"
          type="password"
          value={newpass.confirmPass || ""}
          sx={{ bgcolor: "white", width: "80%" }}
        />
        {message?.message ? (
          <Box sx={{ color: "white" }}>{message.message}</Box>
        ) : null}

        {message?.success ? null : (
          <Button
            variant="contained"
            onClick={() => handleSaveNewPasswordButton()}
          >
            Сохранить пароль
          </Button>
        )}
        <Box sx={{ display: "flex", gap: "5px", padding: "10px 0" }}>
          <ArrowBackIcon sx={{ color: "white" }} />
          <Link to={"/login"} style={{ textDecoration: "none" }}>
            <Typography sx={{ color: "white", cursor: "pointer" }}>
              Назад
            </Typography>
          </Link>
        </Box>
      </Box>
    </div>
  );
}
